import {
  useSourceRecordAggregate,
  useWebhookLogStatusCountsByCorporationId,
} from '@commenda/api/new-sales-tax/data-review';

export const useIntegrationSyncAndValidationProgressStatus = (
  corporationId: number
) => {
  const { data: sourceRecordStatusAggregate } =
    useSourceRecordAggregate(corporationId);

  const { data: webhookRecordsStatusAggregate } =
    useWebhookLogStatusCountsByCorporationId(corporationId);

  const isIntegrationSyncRecordDataProcessing = () => {
    if (webhookRecordsStatusAggregate?.length) {
      const hasProcessingWebhooks = webhookRecordsStatusAggregate.some(
        (companyData) => {
          const counts = companyData.data;
          return (
            counts?.pending > 0 ||
            counts?.retryPending > 0 ||
            counts?.queued > 0 ||
            counts?.processing > 0
          );
        }
      );
      if (hasProcessingWebhooks) return true;
    }

    // Check source record status
    if (sourceRecordStatusAggregate) {
      return (
        sourceRecordStatusAggregate?.validationPending > 0 ||
        sourceRecordStatusAggregate?.validationInProgress > 0 ||
        sourceRecordStatusAggregate?.exportInProgress > 0 ||
        sourceRecordStatusAggregate?.readyForExport > 0
      );
    }

    return false;
  };

  const isIntegrationSyncRecordInProgressForIntegration = (
    rootfiCompanyId: number
  ) => {
    if (webhookRecordsStatusAggregate?.length) {
      const integration = webhookRecordsStatusAggregate.find(
        (data) => data.rootfiCompanyId === rootfiCompanyId
      );

      const hasProcessingWebhooks =
        integration?.data?.processing > 0 ||
        integration?.data?.queued > 0 ||
        integration?.data?.retryPending > 0 ||
        integration?.data?.pending > 0;

      return hasProcessingWebhooks;
    }

    return false;
  };

  return {
    isIntegrationSyncRecordDataProcessing,
    isIntegrationSyncRecordInProgressForIntegration,
  };
};
